module.exports = __webpack_public_path__ + "static/media/ic172amg.cec73c68.jpg";